import React, { useContext } from "react";
import { AppStore } from "../../app/store";
import { Plan } from "../../@types";
import Details from "./MAPDPlanDetailSections";
import { PlanHeader } from "./../../components";
import { hasAbstractBenefits } from "./AbstractBenefits/AbstractBenefitsHelpers";
import { PreviewContext, useCosts } from "../../helpers";

const MAPDPlanDetails: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const {
    state: { prescriptions },
  } = useContext(AppStore.AppContext);
  const drugCostInfo = useCosts(plan);
  const previewMode = useContext(PreviewContext);

  const hasOptionalBenefits = !!plan.optional_benefits.length;

  return (
    <article>
      <PlanHeader plan={plan} />

      <div
        className={`PlanDetails__contentContainer${
          previewMode ? " preview-mode" : ""
        }`}
      >
        {!previewMode && (
          <Details.Navigation
            plan={plan}
            hasAbstractBenefits={hasAbstractBenefits(plan)}
            hasDrugs={prescriptions.length > 0}
            hasOptionalBenefits={hasOptionalBenefits}
            hasDrugCosts={!!drugCostInfo.costs.length}
          />
        )}

        <div className="plan-details-content">
          <Details.Overview plan={plan} />

          <Details.Benefits plan={plan} />

          <Details.ExtraBenefits plan={plan} />

          {hasOptionalBenefits && (
            <Details.OptionalSupplementalBenefits plan={plan} />
          )}

          <Details.DrugCoverage plan={plan} drugCostInfo={drugCostInfo} />

          {!previewMode && <Details.StarRatings plan={plan} />}

          <Details.DocumentsAndContact plan={plan} />
        </div>
      </div>
    </article>
  );
};

export default MAPDPlanDetails;
